import * as fromDatatype from "../datatype-library/index";

export interface bl_del_logistic_hub_hdr_RowInterface{
    guid: fromDatatype.GuidDataFieldInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    descr: fromDatatype.VarcharDatatypeInterface;
    address_line_1: fromDatatype.VarcharDatatypeInterface;
    address_line_2: fromDatatype.VarcharDatatypeInterface;
    address_line_3: fromDatatype.VarcharDatatypeInterface;
    address_line_4: fromDatatype.VarcharDatatypeInterface;
    address_line_5: fromDatatype.VarcharDatatypeInterface;
    city: fromDatatype.VarcharDatatypeInterface;
    country: fromDatatype.VarcharDatatypeInterface;
    postal_code: fromDatatype.VarcharDatatypeInterface;
    phone: fromDatatype.VarcharDatatypeInterface;
    state: fromDatatype.VarcharDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    property_json : fromDatatype.JsonDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    acl_config : fromDatatype.JsonDatatypeInterface;
    cl_policy : fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;

}



export class bl_del_logistic_hub_hdr_RowClass
    implements bl_del_logistic_hub_hdr_RowInterface{
    
    guid: fromDatatype.GuidDataFieldInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    descr: fromDatatype.VarcharDatatypeInterface;
    address_line_1: fromDatatype.VarcharDatatypeInterface;
    address_line_2: fromDatatype.VarcharDatatypeInterface;
    address_line_3: fromDatatype.VarcharDatatypeInterface;
    address_line_4: fromDatatype.VarcharDatatypeInterface;
    address_line_5: fromDatatype.VarcharDatatypeInterface;
    city: fromDatatype.VarcharDatatypeInterface;
    country: fromDatatype.VarcharDatatypeInterface;
    postal_code: fromDatatype.VarcharDatatypeInterface;
    phone: fromDatatype.VarcharDatatypeInterface;
    state: fromDatatype.VarcharDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    property_json : fromDatatype.JsonDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    acl_config : fromDatatype.JsonDatatypeInterface;
    cl_policy : fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;

    

}
